import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-old-email',
  templateUrl: './old-email.component.html',
  styleUrls: ['./old-email.component.css'],
})
export class OldEmailComponent implements OnInit {
  public isCorrectPassword: boolean = true;
  public password: string = '';

  public control: any = '';

  public currentUser: any;
  public userInitial: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.authService.me$.subscribe((val) => {
      this.currentUser = val;
    });
  }

  confirm() {
    const username =
      this.currentUser.role === 'physiotherapist'
        ? this.currentUser.email
        : this.currentUser.personal_information.email;

    this.authService.checkPassword(username, this.password).subscribe(
      (userCredentials) => {
        this.authService.setCurrentPassword(this.password);
        setTimeout(() => {
          this.router.navigate(['change-email']);
        }, 300);
      },
      (error) => {
        this.isCorrectPassword = false;
      },
    );
  }
}
